module.exports = __webpack_public_path__ + "static/media/logoimage.e3d1f734.svg";